import cookie from "react-cookies";
import api from "../utils/api";
const webcookie = {
  initCookies(_name, _value) {
    let cookieValue = cookie.load(_name);
    if (!cookieValue) {
      this.setCookie(_name, _value);
    }
  },
  setCookie(_name, _value) {
    const pts = window.location.pathname.split("/");
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    cookie.save(_name, _value, {
      path: `/${pts[1] || "/en"}`,
      expires
    });
  },
  getCookie(_name) {
    const strCookies = document.cookie;
    const array = strCookies.split(';');
    for (let i = 0; i < array.length; i++) {
      let item = array[i].split("=");
        if (item[0].replace(/\s*/g,"") == _name) {
            return item[1];
        }
    }
    return null;
  },
  injectHeadScript(jsCode) {
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.innerText = jsCode;
    s.id = "googlescript";
    document.getElementsByTagName("head")[0].appendChild(s);
  },
  addHeadScript(scriptSrc) {
    let head = document.getElementsByTagName("head")[0];
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = scriptSrc;
    head.appendChild(script);
  },
  addSomeScriptDynamically(lang) {
    //in case of external script
    api.gtm.get({ lang: lang }).then(res => {
      let gtmId = res;
      this.injectHeadScript(
        `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`
      );
      this.appendGTMHtml(gtmId);
    });
  },
  appendGTMHtml(gtmId) {
    let noscript = document.createElement("noscript");
    let iframe = document.createElement("iframe");
    let body = document.getElementsByTagName("body")[0];
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.width = "0";
    iframe.height = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    body.appendChild(noscript);
  }
};
export default webcookie;
